import { NgModule } from '@angular/core';

import { StartModule } from '@ap/tokens-browser';

import { LogoutModalModule } from '../logout-modal/logout-modal.module';

import { StartWrapperComponent } from './start.wrapper.component';

/**
 * @name StartWrapperModule
 * @ngdoc module
 */
@NgModule({
    declarations: [StartWrapperComponent],
    imports: [LogoutModalModule, StartModule],
    exports: [StartWrapperComponent]
})
export class StartWrapperModule {}
